import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";
import { fetchEncodedToken } from "../../js/getEncodedToken";
import { clientConfigPath, current_client_config, master_client_config } from "../../config/Constant";
import { setDeviceIdentifier, setSessionToken } from "../Reducers/appConfigReducer";

export const registerDevice = (callback) => {


  return async dispatch => {

    const deviceType = Platform.OS
    const room = await AsyncStorage.getItem('room');
    const roomID = await AsyncStorage.getItem('roomID');
    const device_name = await AsyncStorage.getItem("deviceName")

    const getEncodedToken = fetchEncodedToken();

    try {

      const response = await clientConfigPath.post('/guestDevice/register', {
        header: {
          deviceTokenIdentifier: null,
          deviceType: deviceType,
        },
        payload: {
          webAppData: getEncodedToken.encodedData,
          key: 'public-key',
          location: roomID ? roomID : null,
          roomId: room ? room : null,
          deviceName: device_name,
        },
      })

      let data = response.data;
      console.log('register------>', data);

      let sessionToken = data.payload.sessionToken;
      let DeviceIdentifier = data.payload.identifier;
      console.log('sessionToken & identifier', sessionToken, DeviceIdentifier);

      await AsyncStorage.setItem('sessionToken', sessionToken)
      await AsyncStorage.setItem('DeviceIdentifier', DeviceIdentifier);
      await AsyncStorage.setItem("current_client_config", current_client_config)

      dispatch(setSessionToken(sessionToken));
      dispatch(setDeviceIdentifier(DeviceIdentifier));

      if(master_client_config == current_client_config){
        await AsyncStorage.setItem("corporateSessionToken", data.payload.sessionToken);
      }

      callback(true);
    } catch (error) {
      callback(false)
    }
  };
};